import React from 'react';
import { motion } from 'framer-motion';
export function WhySmootherSection() {
  const steps = [{
    number: '01',
    title: 'Hydration-first base',
    description: 'Electrolytes before caffeine hits.'
  }, {
    number: '02',
    title: 'Controlled caffeine',
    description: '125mg per scoop for a cleaner daily lift.'
  }, {
    number: '03',
    title: 'Smooth focus support',
    description: 'Built to feel switched on, not wired.'
  }];
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-155">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-4 mb-12" data-id="element-157">
          <h2 className="font-headline text-4xl md:text-5xl text-charcoal" data-id="element-158">
            Why it feels smoother.
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-159">
            Zesty starts with hydration, then layers in caffeine and focus
            support for a smoother daily lift.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-160">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="text-center space-y-3" data-id="element-161">
              <div className="text-5xl font-headline text-lime" data-id="element-162">
                {step.number}
              </div>
              <h3 className="font-semibold text-xl text-charcoal" data-id="element-163">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-164">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}